var initialWalletControllerState = {
    provider: null,
    web3Provider: null,
    address: undefined,
    chainId: undefined,
};
export default initialWalletControllerState;
